import {
  createInstance,
  OptimizelyDecideOption,
} from '@optimizely/optimizely-sdk'
import { OPTIMIZELY_COOKIE_NAME } from '@awaze/mfe-common.lib.optimizely'
import { OptimizelyAttributes } from './types'
import { OPTIMIZELY_FLAGS_ENUM } from './optimizely-const'

export const getWishlistIconDecision = async (
  optimizelyKey: string,
  cookies: Record<string, string>,
  attributes: OptimizelyAttributes,
  headerData: {
    desktopMenu?: {
      menuItems?: Array<{ type?: string; link?: { href?: string } }>
    }
  } | null,
): Promise<boolean> => {
  let shouldShowWishlistIcon = false
  let optimizelyClient = null

  try {
    optimizelyClient = createInstance({
      sdkKey: optimizelyKey,
    })

    const result = await optimizelyClient?.onReady()

    if (result?.success) {
      const user = optimizelyClient?.createUserContext(
        cookies[OPTIMIZELY_COOKIE_NAME],
        attributes,
      )

      if (user) {
        const decision = user.decide(OPTIMIZELY_FLAGS_ENUM.WISHLIST_ICON, [
          OptimizelyDecideOption.INCLUDE_REASONS,
        ])

        // Check if wishlist icon exists in header data and experiment decision
        const wishListIcon = headerData?.desktopMenu?.menuItems?.find(
          (item) => item.type === 'wishlist',
        )

        shouldShowWishlistIcon =
          !!wishListIcon &&
          !!wishListIcon.link?.href &&
          decision.variationKey === 'wishlist_entry_points_visible'
      }
    }
  } catch (error) {
    console.error('Error getting Optimizely decision:', error)
  } finally {
    // Clean up the client to prevent memory leaks
    if (optimizelyClient) {
      await optimizelyClient?.close().catch((error) => {
        console.warn(`Error closing Optimizely: ${error.message}`)
      })
    }
  }

  return shouldShowWishlistIcon
}
